module.exports = __webpack_public_path__ + "img/27.d1ccc4c3.jpg";